<table class="mdl-data-table mdl-js-data-table mdl-data-table--selectable mdl-shadow--2dp monitoring-table">
    <thead>
        <tr>
            <th style="width: 5%" class="header-cell">#</th>
            <th style="width: 7%" class="header-cell">Id</th>
            <th style="width: 18%" class="header-cell">Event Type</th>
            <th *ngIf="showParentType" style="width: 10%" class="header-cell">Parent Type</th>
            <th [style.width]="showParentType ? '17%' : '27%'" class="header-cell">User</th>
            <th style="width: 10%" class="header-cell">Created</th>
            <th [style.width]="showParentType ? '18%' : '28%'" class="header-cell">Details</th>
            <th style="width: 5%" class="header-cell">Actions</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let event of eventsList; let i = index" app-process-event-row [event]="event" [index]="i+1"
            [showParentType]="showParentType"></tr>
    </tbody>
</table>